import PropTypes from 'prop-types';
import { TYPES, PLACEMENTS } from './constants';

export const TOOLTIP_PROP_TYPES = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(TYPES)),
  placement: PropTypes.oneOf(Object.values(PLACEMENTS)),
};
